import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Tombstone } from 'app/models/Tombstone';
import { BackendService } from 'app/services/backend.service';
import { FirebaseService } from 'app/services/firebase.service';
import { MatPaginator } from '@angular/material/paginator';
import { Person } from 'app/models/Person';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatInput } from '@angular/material/input';
import { CemeterySelectedService } from 'app/services/cemetery-selected.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
})
export class ListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  title = 'aplikacja-webowa';
  private url = 'http://156.17.130.230:8040/api/Images/';
  private filterValue: string;
  tombstones: Array<Tombstone>;
  tombstonesFiltered: Array<Tombstone>;
  people: Array<Person> = [];
  peopleDataSource = new MatTableDataSource<Person>();
  images: Array<String>;
  displayedColumns: string[] = [
    'lastName',
    'firstName',
    'birthDate',
    'dateOfDeath',
    'extraInfo',
    'cemetery',
    'details',
  ];
  constructor(
    private tombstoneService: FirebaseService,
    private selectedCemeteriesService: CemeterySelectedService,
    private router: Router
  ) {
    if (localStorage.getItem('filterValue') == null) {
      localStorage.setItem('filterValue', '');
    }

    this.filterValue = localStorage.getItem('filterValue');
    this.applyFilterString(this.filterValue);
  }

  ngAfterViewInit() {
    this.peopleDataSource.paginator = this.paginator;
    this.peopleDataSource.sort = this.sort;
  }

  ngOnInit() {
    this.getData();
    if (localStorage.getItem('filterValue') == null) {
      localStorage.setItem('filterValue', '');
    }
    this.peopleDataSource.filterPredicate = (
      person: Person,
      filter: string
    ) => {
      let filterSplitted = filter.split(' ');
      let match = 0;
      for (let i = 0; i < filterSplitted.length; i++) {
        let text = filterSplitted[i];
        if (
          person.firstName != undefined &&
          person.firstName.toLocaleLowerCase().includes(text)
        ) {
          match++;
        } else if (
          person.lastName != undefined &&
          person.lastName.toLocaleLowerCase().includes(text)
        ) {
          match++;
        } else if (
          person.dateOfDeath != undefined &&
          person.dateOfDeath.toString().toLocaleLowerCase().includes(text)
        ) {
          match++;
        } else if (
          person.birthDate != undefined &&
          person.birthDate.toString().toLocaleLowerCase().includes(text)
        ) {
          match++;
        } else if (
          person.cemetery != undefined &&
          person.cemetery.toLocaleLowerCase().includes(text)
        ) {
          match++;
        }
      }
      return match == filterSplitted.length;
    };
    this.filterValue = localStorage.getItem('filterValue');

    // this.imagesService
    //   .getImages()
    //   .subscribe((res) => (this.images = res as Array<String>));
  }

  getFilterValue() {
    return this.filterValue;
  }

  applyFilter(event: Event) {
    this.applyFilterString((event.target as HTMLInputElement).value);
  }

  applyFilterString(filterVal: string) {
    localStorage.setItem('filterValue', filterVal);
    this.peopleDataSource.filter = filterVal.toLowerCase();

    if (this.peopleDataSource.paginator) {
      this.peopleDataSource.paginator.firstPage();
    }
  }

  getData() {
    this.tombstoneService.getTombstones().subscribe((res) => {
      this.tombstones = res as Array<Tombstone>;
      this.selectedCemeteriesService.selectedCemeteries$.subscribe((c) => {
        this.tombstonesFiltered = this.tombstones.filter(
          (t) => c.includes(t.cemetery) || c.length === 0
        );
        this.people = [];
        this.tombstonesFiltered.forEach((t: Tombstone) => {
          if (t.person != null) {
            t.person.forEach((p: Person) => {
              p.cemetery = t.cemetery;
              p.tombstone = t;
              this.people.push(p);
            });
          }
        });
        this.peopleDataSource.data = this.people;
      });
      // res.forEach((t: Tombstone) => {
      //   if (t.person != null) {
      //     t.person.forEach((p: Person) => {
      //       p.cemetery = t.cemetery;
      //       p.tombstone = t;
      //       this.people.push(p);
      //     });
      //   }
      // });
      // this.peopleDataSource.data = this.people;
    });
  }

  onClick() {
    this.tombstones.forEach((e: Tombstone) => {
      this.tombstoneService
        .getPeople(e.name)
        .subscribe((res) => console.log(res));
    });
  }

  goToTombstone(t: Tombstone) {
    const id = t ? t.name : null;
    this.router.navigate(['details', id]);
  }
}
